import { Component, OnInit, ViewChild, ElementRef, NgModule } from '@angular/core';
import { FacturationService } from '../../../services/facturation/facturation.service';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { AlertsService } from '../../../services/shared/alerts.service';
import { IFacturation } from 'src/app/models/facturation'
import { map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { and } from '@angular/router/src/utils/collection';
declare var $: any;

@Component({
  selector: "facturation",
  templateUrl: "./facturation.component.html",
  styleUrls: ["./facturation.component.scss"],
})

export class FacturationComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  facturations: any[] = [];
  UUID: any;
  FOLIO: any;
  SERIE: any;
  fechaInicio: any;
  fechaFin: any;
  VENDEDOR: number;
  petition: boolean = false
  factures: any[] = [];
  currentPage: number = 1;
  pageSize: number = 5;
  options = {
    format: "yyyy-mm-dd",
    maxDate: new Date(),
    autoClose: true,
    showClearBtn: true
  };
  paginatedFactures: any[];

  constructor(
    private _facturations: FacturationService,
    private _alert: AlertsService,
  ) {

  }

  onPageChange(event: any) {
    this.currentPage = event.pageIndex + 1;
    this.updatePaginator();
  }

  updatePaginator() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedFactures = this.factures.slice(startIndex, endIndex);
  }

  async ngOnInit() {
    this.fechaInicio = $("#fechaInicio").datepicker(this.options);
    this.fechaFin = $("#fechaFin").datepicker(this.options);
    const response = await this.getFactures();
    if (response.success) {
      this.factures = response.data
      this.factures.map(e => e.id_sucursal = this.asigNameBranch(e.id_sucursal));
      this.updatePaginator();
    }
  }

  asigNameBranch(id : number) {
    switch (id) {
      case 16:
        return 'CAMBACEO AREA METROPOLITANA';
      case 41:
        return 'CAMBACEO CUERNAVACA';
      case 42:
        return 'CAMBACEO CUAUTLA';
      case 43:
        return 'CAMBACEO JOJUTLA';
      default:
        break;
    }
  }

  async sendFilter() {
    let data = {
      UUID: this.UUID,
      FOLIO: this.FOLIO,
      fechaInicio: this.fechaInicio.val(),
      fechaFin: this.fechaFin.val(),
      VENDEDOR: this.VENDEDOR
    };
    this.filterAndModifyDataByDateRange(data);
  }

  filterAndModifyDataByDateRange(data: any) {
    const validitionCamp = Object.values(data).some(value => value !== '' && value !== undefined);
    if (!validitionCamp) {
      this._alert.info({ text: 'Debes ingresar al menos un criterio de busqueda' });
      return;
    }
    this.paginatedFactures = this.factures.filter((factura) => {
      return (!data.fechaInicio || (
        factura.fecha_venta >= data.fechaInicio && factura.fecha_venta <= data.fechaFin
      )) && (!data.UUID || factura.uuid === data.UUID) && (!data.FOLIO || factura.folio === data.FOLIO) && (!data.VENDEDOR || factura.id_vendedor === parseInt(data.VENDEDOR));
    });
  }

  async getFactures() {
    try {
      this.petition = true
      const response = await this._facturations.getFactures();
      console.log(response);
      
      if (response.success) {
        this.petition = false;
        this.updatePaginator();
        return response;
      }
    } catch (error) {
      this.petition = false;
      return error;
    }
  }

  async descargarTablaComoCSV() {
    const separator = ',';
    const keys = ['uuid', 'folio', 'nombre_cliente', 'id_sucursal', 'fecha_venta', 'subtotal', 'Estado'];
    const csvContent =
      keys.join(separator) +
      '\n' +
      this.factures.map(item => keys.map(key => item[key]).join(separator)).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Reporte_de_Facturacion.csv'; 
    a.click();
    URL.revokeObjectURL(url);
  }


  getEstadoStyle(estado: string) : string {
    switch (estado) {
      case 'Vigente':
        return 'green';
      case 'En Proceso':
        return '#FFCD00';
      case 'Cancelado':
        return 'red';
      default:
        return 'black';
    }
  }

  async botonx(parametro: any) {
    try {
      switch (parametro.Estado) {
        case 'En Proceso':
          return this._alert.info({ title: 'Atención', text: 'Tu factura esta en proceso de cancelación espera al menos 72hrs' });
        case 'Vigente' :
        const alert = await Swal.fire({
          title: '<span style="color: #243B6E;">¿Deseas cancelar la factura?</span>',
          showCancelButton: true,
          input: 'select',
          inputOptions: {
            '': 'Motivo',
            '01': '01 Comprobante emitido con errores con relacion',
            '02': '02 Comprobante emitido sin errores con relacion',
            '03': '03 No se llevo a cabo la operacion',
            '04': '04 Operacion nominativa relacionada en una factura',
          },
        });
        if (!alert.dismiss) {
          if (alert.value.includes('0')) {
            if (alert.value.includes('01')) {
              const res = await Swal.fire({
                title: '<span style="color: #243B6E;">Comprobante emitido con errores con relacion</span>',
                text: 'Folio fiscal de remplazo',
                input: 'text',
              });
  
              const facturacionData: IFacturation = {
                rfc: parametro.rfc_emisor,
                uuid: parametro.uuid,
                motivo: alert.value,
                folioSustitucion: res.value,
              };
              if (!res.dismiss) {
                if (res.value.length < 36) { 
                  throw new Error('El folio debe contener 36 caracteres');
                }
                const data = await this._facturations.postCancel(facturacionData); 
                if (data.success) {
                  if (parametro.subtotal > 1000) {
                      parametro.Estado = 'En Proceso';
                      this.updatePaginator();
                      return this._alert.success({ title: 'Enviado exitosamente', text: 'Debes esperar al menos 72 horas para que se complete la solicitud'  });
                  } else {
                      parametro.Estado = 'Cancelado';
                      this.updatePaginator();
                      return this._alert.success({ title: 'Enviado exitosamente', text: 'Factura cancelada'});
                  }
                }
              }
            } else { 
              const alert3 = await Swal.fire({
                title: '<span style="color: #243B6E; font-size: 24px;">Cancelar la factura</span>',
                text: '¿Estás seguro de que quieres continuar con la cancelación de la factura?',
                showCancelButton: true,
                imageUrl: 'src/assets/img/icon/icono_confirm.png',
                imageWidth: 100,
                imageHeight: 100,
                imageAlt: 'Custom image',
              });
  
              const facturacionData: IFacturation = {
                rfc: parametro.rfc_emisor,
                uuid: parametro.uuid,
                motivo: alert.value,
                folioSustitucion: '',
              };              
  
              if (!alert3.dismiss) {
                const data = await this._facturations.postCancel(facturacionData);
                if (data.success) {
                  if (parametro.subtotal > 1000) {
                      parametro.Estado = 'En Proceso';
                      this.updatePaginator();
                      return this._alert.success({ title: 'Enviado exitosamente', text: 'Debes esperar al menos 72 horas para que se complete la solicitud'  });
                  } else {
                      parametro.Estado = 'Cancelado';
                      this.updatePaginator();
                      return this._alert.success({ title: 'Enviado exitosamente', text: 'Factura cancelada'});
                  }
                }
              }
            }
          } else {
            throw new Error('Debes seleccionar un motivo');
          }
        }
      }
    } catch (error) {
      if (error.message === 'El folio debe contener 4 caracteres') {
        this._alert.error({ text: error.message, title: 'Error de validación' });
      } else {
        this._alert.error({ text: error.message, title: 'Ocurrió un error' });
      }
    } finally {
      const index: number = this.facturations.findIndex(
        (x) => x.parametro === parametro
      );
      this.facturations.splice(index, 1);
    }
  }
}
